export const adminMenu = [
  {
    icon: "blog",
    title: "Blog Posting",
  },
  {
    icon: "dashboard",
    title: "DAshBorad",
  },
];

// Category Array
export const categories = [
  "Technology",
  "Lifestyle",
  "Health",
  "Education",
  "Travel",
  "Fashion",
  "Food",
  "Finance",
  "Sports",
  "Entertainment",
];

// Blogger Array
export const bloggersArr = [
  "Carl James",
  "Aella Smith",
  "Aliyan Margaret",
  "Elif Shafak",
  "Sarah Lee",
  "Michael Davis",
  "Adam William",
  "David Wilson",
  "Olivia Harris",
  "James Clark",
];
